<template>
<div id="app">
  <router-view />
  </div>
</template>

<script>
import storage from './utils/storage';
export default {
  name: 'App',
  created (){
     let href1 = window.location.href.split('#')[0];
     console.log(" localhref0 =====  " + href1)
     storage.setS('rootUrl', href1)
    //  wx.error(function(res){
    //    console.log("wx.error" +JSON.stringify(res))
    //  })
  }
};
</script>